export const host = 'http://genebreaker.cmmt.ubc.ca:8080/'
// export const host = 'http://127.0.0.1:5000/'
